import type { User } from '@/types/user';

const STORAGE_KEY = 'adminUser';

/**
 * Updates the cached user that every `useAuth` consumer reads, then tells them
 * to re-read it.
 *
 * `authChange` is the app's existing same-tab refresh signal. A plain
 * localStorage write is not enough on its own: `storage` events only fire in
 * *other* tabs, so nothing in this one would notice.
 *
 * Merges rather than replaces, so a partial payload can't drop fields the
 * cached copy already holds.
 */
export function syncCachedUser(user: Partial<User>): void {
  try {
    const cached = localStorage.getItem(STORAGE_KEY);
    const merged = cached ? { ...JSON.parse(cached), ...user } : user;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
    window.dispatchEvent(new Event('authChange'));
  } catch {
    // A corrupt cache is not worth failing a successful save over — the next
    // login or profile load rewrites it wholesale.
  }
}
